import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import './assets/fonts/fonts.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/900.css';
import { AuthProvider } from './context/AuthContext';
import posthog from 'posthog-js';

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  person_profiles: 'always',
  // Use localStorage instead of cookies to ensure PostHog works in
  // Playwright/Chromium automation environments where third-party
  // cookies may be blocked or restricted.
  persistence: 'localStorage',
  // Disable cross-subdomain cookies to avoid issues in test/automation
  // browser contexts.
  cross_subdomain_cookie: false,
  // Disable secure cookie requirement for localhost testing
  secure_cookie: window.location.protocol === 'https:',
  // Flush queued events on page unload using sendBeacon. This is
  // critical for automated tests where navigations can cancel
  // in-flight fetch requests.
  before_unload: true,
  // Flush events every 1 second so they don't accumulate
  flush_interval: 1000,
  // Mark posthog as ready for automated tests to wait on
  loaded: function(ph) {
    window.__POSTHOG_READY__ = true;
    // Expose posthog globally so Playwright automation can access it
    // via page.evaluate(). Without this, posthog-js is module-scoped
    // and window.posthog remains undefined in headless tests.
    window.posthog = ph;
  },
  disable_compression: true,
});

if (process.env.NODE_ENV === 'development') {
  const disableOverlay = () => {};
  window.__REACT_ERROR_OVERLAY__?.stopReportingRuntimeErrors?.();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);